import React, { createContext, useContext, useState, useEffect } from 'react';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from 'firebase/firestore'; 

const auth = getAuth(app);
const db = getFirestore(app);

// Créez un contexte utilisateur
const UserContext = createContext();

// Créez un composant Context Provider
export function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Indique si le chargement est en cours


  useEffect(() => {
    // Utilisez Firebase pour surveiller l'état de l'utilisateur
    const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
      setIsLoading(true); // Début du chargement

      if (authUser) {
        //setUser(authUser);

        const docRef = doc(db, 'utilisateurs', authUser.uid);

        let data = await fetchUser(docRef); 

        if(data.type === "chef" || data.type === "admin" || data.type === "responsable" || data.type === "operateur"){
          let obj = {user: authUser, userData: data};
          setUser(obj);
        }else {
          setUser(null);

          await auth.signOut(); // Déconnectez l'utilisateur
        }
        

      } else {
        setUser(null);
      }

      setIsLoading(false); // Fin du chargement
    });

    // Nettoyez l'effet lors du démontage du composant
    return () => unsubscribe();
  }, []);


  return (
    <UserContext.Provider value={{user:user, isLoading:isLoading, setUser: setUser}}>
      {children}
    </UserContext.Provider>
  );
}


// Récupérez le document Firestore
const fetchUser = async (docRef) => {
  try {
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      // Le document existe, vous pouvez accéder à ses données
      return docSnap.data();
    } else {
      // Le document n'existe pas
      console.log('Document not found!');
      return null; 
    }
  } catch (error) {
    console.error('Error fetching document:', error);
    return null; 
  }
};


// Créez un hook personnalisé pour accéder au contexte utilisateur
export function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser doit être utilisé à l'intérieur d'un UserProvider");
  }
  return context;
}

/**
 * extrait l'id client d'un path (référence)
 * @param {*} path 
 * @returns 
 */
export function extractIds(path) {
  const pathParts = path.split('/'); // Séparer les parties du chemin par "/"
  const ids = {};

  // Extraire les paramètres selon la position dans l'URL
  if (pathParts.includes('clients')) {
    ids.client_id = pathParts[pathParts.indexOf('clients') + 1];
  }
  /*
  if (pathParts.includes('sites')) {
    ids.site_id = pathParts[pathParts.indexOf('sites') + 1];
  }
  if (pathParts.includes('silos')) {
    ids.silo_id = pathParts[pathParts.indexOf('silos') + 1];
  }
  if (pathParts.includes('machines')) {
    ids.machine_id = pathParts[pathParts.indexOf('machines') + 1];
  }
  if (pathParts.includes('composants')) {
    ids.composant_id = pathParts[pathParts.indexOf('composants') + 1];
  }*/

  return ids;
}

export const isAdmin = (user) => {
  return user.userData.type === "admin";
}

export const isChief = (user) => {
  return user.userData.type === "chef";
}

export const isManager = (user) => {
  return user.userData.type === "responsable";
}

export const isAgent = (user) => {
  return user.userData.type === "operateur";
}